import { createContext, useContext } from 'react';

/** A source the expert asked to read: the catalog record when there is one, and the page behind it. */
export type SourceRef = {
  publicationId: number;
  url: string;
  /** What the link said, shown while the record loads and if it has no title. */
  title: string;
  from: 'sentence' | 'changed_recently';
};

/**
 * Opens a source's details inside the reply draft, in place of the step, so
 * the expert reads the evidence without leaving the sheet or stacking a second
 * one over it. The sheet provides it; a link outside one finds none and opens
 * the page instead.
 */
export const SourceViewerContext = createContext<((source: SourceRef) => void) | null>(null);

export function useSourceViewer() {
  return useContext(SourceViewerContext);
}
